import React, { useEffect, useRef } from 'react'
import {compose, lifecycle, withState} from 'recompose'
import {iframeResizer} from 'iframe-resizer'


function newBanner({cycle, setCycle, loaded}) {
  const observerRef = useRef(null);

  // HACK: костыльная правка высоты одного из баннеров
  useEffect(() => {
    const iframe = document.getElementById('banner1');
    iframe.addEventListener('load', () => {
      const handler = () => {
        const iframe = document.getElementById('banner1');
        const targetHeight = iframe.contentWindow.document.querySelector('.gwd-page-content').clientHeight;
        iframe.style.height = `${targetHeight}px`;
      };
      window.addEventListener('resize', handler);

      observerRef.current = new MutationObserver((mutations, observer) => {
        if (
          mutations.find(({ type, addedNodes }) => Boolean(
            type === 'childList' &&
            [...addedNodes].find(node => Boolean(node && node.classList && node.classList.contains('gwd-page-wrapper'))))
          )
        ) {
          handler();
          observer.disconnect();
        }
      });
      observerRef.current.observe(iframe.contentWindow.document.body, {
        childList: true,
        attributes: true,
        subtree: true,
      });
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    }
  }, []);

  // HACK: костыльная правка рамок одного из баннеров
  useEffect(() => {
    const iframe = document.getElementById('banner3');
    iframe.addEventListener('load', () => {
      const targetElement = document.getElementById('banner3').contentDocument.querySelector('.gwd-page-wrapper');
      [...targetElement.children].forEach(element => !element.classList.contains('gwd-page-content') && element.remove());
    });
  }, []);

  return (
    <div style={{position: 'relative'}}>
      <div style={{...(cycle + 1 != 1) && {height: 0}}}>
        <iframe
          id={`banner1`}
          src={`/media/banner4/index.html`}
          style={{
            ...(cycle + 1 != 1) && {
              opacity: 0,
            },
            maxHeight: 580,
            border: 'none',
            minWidth: '100%',
            width: '100%',
          }}
          scrolling={"no"}
        />
      </div>
      <div style={{...(cycle + 1 != 2) && {height: 0}}}>
        <iframe
          id={`banner2`}
          src={`/media/banner1/index.html`}
          style={{
            ...(cycle + 1 != 2) && {
              opacity: 0,
            },
            maxHeight: 580,
            border: 'none',
            minWidth: '100%',
            width: '100%',
          }}
          scrolling={"no"}
        />
      </div>
      <div style={{...(cycle + 1 != 3) && {height: 0}}}>
        <iframe
          id={`banner3`}
          src={`/media/banner2/index.html`}
          style={{
            ...(cycle + 1 != 3) && {
              opacity: 0,
            },
            maxHeight: 580,
            border: 'none',
            minWidth: '100%',
            width: '100%',
          }}
          scrolling={"no"}
        />
      </div>
      {
        loaded && (
          <div style={{position: 'absolute', textAlign: 'center', width: '100%', bottom: 2, left: 0, zIndex: 1}}>
            <div
              style={{
                display: 'inline-block',
                cursor: 'pointer',
                width: 50,
                height: 20,
                textAlign: 'center',
              }}
              onClick={() => {
                document.getElementById("banner1").contentWindow.postMessage('refresh', '*')
                setCycle(0)
                window.ChangeBanner = false
              }}
            >
              <div
                style={{
                  height: 5,
                  width: 30,
                  margin: 'auto',
                  marginTop: 8,
                  background: 'rgb(215, 215, 215)',
                  ...(cycle == 0 && {background: 'rgb(23, 61, 176)'})
                }}
              />
            </div>
            <div
              style={{
                display: 'inline-block',
                cursor: 'pointer',
                width: 50,
                height: 20,
                textAlign: 'center',
              }}
              onClick={() => {
                document.getElementById("banner2").contentWindow.postMessage('refresh', '*')
                setCycle(1)
                window.ChangeBanner = false
              }}
            >
              <div
                style={{
                  height: 5,
                  width: 30,
                  margin: 'auto',
                  marginTop: 8,
                  background: 'rgb(215, 215, 215)',
                  ...(cycle == 1 && {background: 'rgb(23, 61, 176)'})
                }}
              />
            </div>
            <div
              style={{
                display: 'inline-block',
                cursor: 'pointer',
                width: 50,
                height: 20,
                textAlign: 'center',
              }}
              onClick={() => {
                document.getElementById("banner3").contentWindow.postMessage('refresh', '*')
                setCycle(2)
                window.ChangeBanner = false
              }}
            >
              <div
                style={{
                  height: 5,
                  width: 30,
                  margin: 'auto',
                  marginTop: 8,
                  background: 'rgb(215, 215, 215)',
                  ...(cycle == 2 && {background: 'rgb(23, 61, 176)'})
                }}
              />
            </div>
          </div>
        )
      }
    </div>
  )
}

const enhance = compose(
  withState('cycle', 'setCycle', 0),
  withState('cycleFunc', 'setCycleFunc', null),
  withState('loaded1', 'setLoaded1', false),
  withState('loaded2', 'setLoaded2', false),
  withState('loaded3', 'setLoaded3', false),
  withState('loaded', 'setLoaded', false),

  lifecycle({
    componentDidMount() {
      document.getElementById("banner1").onload = () => {
        this.props.setLoaded1(true);
      };
      document.getElementById("banner2").onload = () => {
        this.props.setLoaded2(true);
      };
      document.getElementById("banner3").onload = () => {
        this.props.setLoaded3(true);
      };
      const timerId = setInterval(() => {
        if (this.props.loaded1 && this.props.loaded2 && this.props.loaded3) {
          this.props.setLoaded(true)
          clearInterval(timerId);
        }
      }, 20)

      iframeResizer({})
      this.props.setCycleFunc(window.addEventListener("message", (e) => {
        if (e.data == 'ChangeBanner1' && this.props.cycle == 0) {
          document.getElementById("banner2").contentWindow.postMessage('refresh', '*')
        }
        if (e.data == 'ChangeBanner2' && this.props.cycle == 1) {
          document.getElementById("banner3").contentWindow.postMessage('refresh', '*')
        }
        if (e.data == 'ChangeBanner3' && this.props.cycle == 2) {
          document.getElementById("banner1").contentWindow.postMessage('refresh', '*')
        }
        if (
          e.data == 'ChangeBanner1' && this.props.cycle == 0 ||
          e.data == 'ChangeBanner2' && this.props.cycle == 1 ||
          e.data == 'ChangeBanner3' && this.props.cycle == 2
        ) {
          if (this.props.cycle == 2) {
            this.props.setCycle(0)
          } else if (this.props.cycle == 0) {
            this.props.setCycle(1)
          } else if (this.props.cycle == 1) {
            this.props.setCycle(2)
          }
          window.ChangeBanner = false
        }
      }, false))
    },
    componentDidUpdate() {
      iframeResizer({})
    },
    componentWillUnmount() {
      if (this.props.cycleFunc) {
        clearInterval(this.props.cycleFunc)
      }
    }
  })
)

export default enhance(newBanner)



// WEBPACK FOOTER //
// ./src/finwhale/common/banner/DefaultBanner.js